module.exports = __webpack_public_path__ + "static/media/Football Frenzy.13030d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images/Football Frenzy.png
// module id = 671
// module chunks = 0